import { render, staticRenderFns } from "./DropdownSimple.vue?vue&type=template&id=f0659e72&scoped=true&"
import script from "./DropdownSimple.vue?vue&type=script&lang=js&"
export * from "./DropdownSimple.vue?vue&type=script&lang=js&"
import style0 from "./DropdownSimple.vue?vue&type=style&index=0&id=f0659e72&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0659e72",
  null
  
)

export default component.exports